import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Agent} from '../../../_models/agent';
import { UserGroup} from '../../../_models/user_group';

import { FormValidator } from '../../../_helpers/form.validator';
import { AgentValidator } from '../../agent.validator';

import { DbTransform } from '../../../_helpers/db.transform';
import { AuxFunction } from '../../../_helpers/aux.function';

import { Globals } from '../../../_globals/globals';

@Component({
  selector: 'app-agent-edit',
  templateUrl: './agent-edit.component.html'
})
export class AgentEditComponent implements OnInit {

  dbt: DbTransform;
  auxFunction: AuxFunction;

  // Id del usuario actual logueado.
  current_user_id: number;

  title: string;
  subtitle: string;

  agentForm: FormGroup;

  permissionList: any;

  // actionModal: boolean;
  // alertModal: boolean;
  // infoModal: boolean;

  // actionInfo: string;
  // alertInfo: string;
  // infoInfo: string;


  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;

  currentGroup: UserGroup;

  @Input() agent: Agent;
  @Input() userGroupList: UserGroup[];
  @Output() updateAgent = new EventEmitter<Agent>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();

  constructor(
    public router: Router,
    private globals: Globals,
    private formBuilder: FormBuilder,
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.agentForm.controls; }

  ngOnInit() {

    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);
    this.auxFunction = new AuxFunction();

    this.current_user_id = Number(localStorage.getItem('user_id'));

    console.log('->->< Usuario actual logueado ID: ' + this.current_user_id);

    console.log(' Agente actual = ');
    console.log(this.agent);

    console.log(' Listado de grupos = ');
    console.log(this.userGroupList);

    const currentEnvironment = localStorage.getItem('enviroment');
    this.permissionList = this.globals.permissionList[currentEnvironment] || [];

    // Se obtiene el grupo indicado para ese usuario.
    this.currentGroup = this.userGroupList.find(item => this.agent[this.dbt.t('group_id')] === item[this.dbt.t('id')]);

    console.log('--> > currentUserGroup = ');
    console.log(this.currentGroup);

    this.agentForm = this.formBuilder.group({
      // id: this.agent[this.dbt.t('id')],
      user_id: this.agent[this.dbt.t('user_id')],
      group_id: this.currentGroup, //this.agent[this.dbt.t('group_id')],
      name: this.agent[this.dbt.t('name')],
      username: [this.agent[this.dbt.t('username')], Validators.required],
      lang: [this.agent[this.dbt.t('lang')], [Validators.required]],
      company: [this.agent[this.dbt.t('company')], [Validators.required]],
      dashboards: this.agent[this.dbt.t('dashboards')],
      delivery: this.agent[this.dbt.t('delivery')],
      stock: this.agent[this.dbt.t('stock')],
      new_password: '', // [this.agent[this.dbt.t('password')], [Validators.required, Validators.minLength(8)]],
      email: [this.agent[this.dbt.t('email')], [Validators.required, Validators.email, Validators.maxLength(120)]],
      enviroment: [this.agent[this.dbt.t('enviroment')], [Validators.required, Validators.maxLength(20)]],
      permissions: this.agent[this.dbt.t('permissions')]
    });

    // this.agentForm.controls.group_id.setValue(null);

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(AgentValidator.templateMessages);

    this.title = 'Módulo de Usuarios';
    this.subtitle = 'Edición de Usuarios';

    this.auxFunction.actionInfo = '¿Desea guardar el usuario?';

    this.auxFunction.infoInfo = 'La acción se ha realizado correctamente.';


    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.agentForm);

    // Preparamos el listado de grupos para poder luego obtener sus nombres rápidamente.
    this.auxFunction.setHashList(this.userGroupList, this.dbt.t('id'), this.dbt.t('name'));

  } // End function OnInit

  changeGroup() {
    console.log('Cambiando grupo de usuario...');
    console.log(event);

  } // End function changeGroup

  changePermission() {
    console.log('Cambiando grupo de permisos...');
    console.log(event);

  } // End function changePermission

  // Función que sirve para comparar en el selector dos elementos complejos.
  // Si devuelve true querrá decir que ese elemento se va a seleccionar.
  compareGroup(t1: UserGroup, t2: UserGroup): boolean {
    // console.log(' ->> Comparando grupos:');
    // console.log(t1);
    // console.log(t2);
    // console.log(' ->>--------------------');

    let result = false;

    if (t1 && t2) {
      // console.log(t1['ID'] + '<->' + t2['ID']);
      result = t1['ID'] === t2['ID'] ? true : false;
    }

    // console.log(' ->> Resultado ------>' + result);

    return result;

	}  // End function compareGroup

  saveAgent(p: {a: Agent, dbt: DbTransform, f: FormGroup, e: EventEmitter<Agent>} | null, aux: any | null): void {

    console.log(' **-> Ejecutando saveAgent...');
    console.log(p);
    console.log(aux);

    // this.agent[this.dbt.t('id')] = this.agentForm.controls.id.value;
    p.a[p.dbt.t('company')] = p.f.controls.company.value;
    p.a[p.dbt.t('name')] = p.f.controls.name.value;
    p.a[p.dbt.t('username')] = p.f.controls.username.value;
    p.a[p.dbt.t('lang')] = p.f.controls.lang.value;
    p.a[p.dbt.t('company')] = p.f.controls.company.value;
    p.a[p.dbt.t('dashboards')] = p.f.controls.dashboards.value;
    p.a[p.dbt.t('delivery')] = p.f.controls.delivery.value;
    p.a[p.dbt.t('stock')] = p.f.controls.stock.value;
    p.a[p.dbt.t('email')] = p.f.controls.email.value;
    p.a[p.dbt.t('enviroment')] = p.f.controls.enviroment.value;
    p.a[p.dbt.t('permissions')] = p.f.controls.permissions.value;
    p.a[p.dbt.t('user_id')] = p.f.controls.user_id.value;

    if (p.f.controls.group_id.value === null || p.f.controls.group_id.value === undefined) {
      p.a[p.dbt.t('group_id')] = 0;
      p.f.controls.group_id.setValue(0);
    } else {
      p.a[p.dbt.t('group_id')] = p.f.controls.group_id.value[p.dbt.t('id')];
    }

    // ATENCIÓN: Si no hay id de usuario se pone para Dialum de momento el 1.
    if (p.f.controls.user_id.value === null || p.f.controls.user_id.value === undefined) {
      p.a[p.dbt.t('user_id')] = 1;
      p.f.controls.user_id.setValue(1);
    } else {
      p.a[p.dbt.t('user_id')] = p.f.controls.user_id.value;
    }

    p.a[p.dbt.t('new_password')] = p.f.controls.new_password.value;

    // NOTA: En el formulario se guarda sólo el ID del grupo antes de enviarlo al controlador.
    p.f.controls.group_id.setValue(p.f.controls.group_id.value[p.dbt.t('id')]);

    // EJEMPLO: Añadir un nuevo campo de control a un formulario.
    // this.agentForm.addControl(
    //   'password',
    //   new FormControl(
    //     this.agent[this.dbt.t('password')],
    //     [Validators.required, Validators.minLength(8)]));

    // NOTA: Se copian los cambios sobre la usuario inicial.
    const element = { ...p.a, ...p.f.value };

    p.e.emit(element);

  } // End function saveAgent


  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateAgent(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.agent.user_id !== null) {
      if (this.agentForm.valid) {
        console.log('-------> Formulario agentForm correcto.');

        // Comprobaciones que no estén definidas ya en la declaración del formulario.
        if (this.agentForm.controls.username.value.trim() === '') {

          this.auxFunction.alertInfo = 'Debe de inscribir un nombre de usuario.';
          this.showInfoModal.emit({value: true, info: this.auxFunction.alertInfo, link: '', skin: 'alert'});

        } else {

          // NOTA: Hay que comprobar si el usuario que se va a modificar coincide con el usuario
          // que actualmente está logueado. Si es así tras realizar la modificación se saldrá
          // de la aplicación y se redireccionará a la página de inicio de sesión.
          if (this.agent[this.dbt.t('user_id')].toString() === this.current_user_id.toString()) {

            this.auxFunction.actionInfo = '<strong>ATENCIÓN:</strong><br>Va a modificar su propio usuario. '
              + 'Tendrá que salir y entrar nuevamente a la aplicación para notar los cambios que realice.<br>¿Desea modificar su usuario?';
          }

          this.auxFunction.showActionModal(true);
        }
      } else {
        console.log('-------> Formulario agentForm NO válido:');
        console.log(this.agentForm);

        this.auxFunction.alertInfo = 'El formulario no está correctamente rellenado:<br>';
        this.showInfoModal.emit({value: true, info: this.auxFunction.alertInfo, link: '', skin: 'alert'});
      }
    } else { // Se va a crear un nuevo usuario.

      // Se rellenan los campos por defecto necesarios para los nuevos usuarios
      // y que no aparecen en el formulario de recopilación de datos.
      // ATENCIÓN: De momento ponemos como entorno directamente "dialum"
      // para pruebas hasta que se tenga lista su base de datos independiente.
      this.agentForm.controls.enviroment.setValue(localStorage.getItem('enviroment')) //('dialum');
      this.agentForm.controls.dashboards.setValue(1);
      this.agentForm.controls.delivery.setValue(0);
      this.agentForm.controls.stock.setValue(0);
      this.agentForm.controls.company.setValue('Dialum');
      this.agentForm.controls.lang.setValue('es');
      // this.agentForm.controls.email.setValue('');
      // this.agentForm.controls.name.setValue('');
      // this.agentForm.controls.username.setValue('');
      // this.agentForm.controls.permissions.setValue(null);
      // this.agentForm.controls.group_id.setValue(1);
      // this.agentForm.controls.permissions.setValue('SuperAdmin');

      // Se validan los campos del formulario.
      if (this.agentForm.valid) {

        this.saveAgent({a: this.agent, dbt: this.dbt, f: this.agentForm, e: this.updateAgent}, null);

        if (this.agentForm.controls.new_password.value === null) {
          this.auxFunction.alertInfo += ' - Debe de introducir una contraseña.<br>';
        }
      } else {
        console.log('-------> Formulario agentForm NO válido para el nuevo usuario:');
        console.log(this.agentForm);

        this.auxFunction.alertInfo = 'El formulario para el nuevo usuarioa no está correctamente rellenado.<br>';
        this.showInfoModal.emit({value: true, info: this.auxFunction.alertInfo, link: '', skin: 'alert'});
      }
    } // End else nuevo usuario.
  } // End function validateAgent

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/agent']);
  } // End function back

} // End Class AgentEditComponent
